import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

interface ContentProps {
  isMinified?: boolean;
  isMobileMode?: boolean;
  isFlatMode?: boolean;
}
export const Content = styled(Box)<ContentProps>`
  flex: 1;

  padding-left: ${({ theme, isMinified, isMobileMode }) =>
    isMinified || isMobileMode ? 0 : theme.spacings.spacing24};
  padding-right: ${({ theme, isMinified, isMobileMode }) =>
    isMinified || isMobileMode ? 0 : theme.spacings.spacing24};
  background-color: ${({ theme }) => theme.colors.canvas};
  @media ${({ theme }) => theme.deviceSize.moreThen.laptopL} {
    padding: ${({ theme, isMinified }) =>
      `0 ${isMinified ? 0 : theme.spacings.spacing32} ${isMinified ? 0 : theme.spacings.spacing48}`};
  }
  ${({ isMobileMode, isFlatMode, theme }) => {
    if (isMobileMode) {
      return css`
        min-height: ${({ theme }) => theme.controls.mobileHeightWithMenu};
        padding: 0px;
        border-radius: ${isFlatMode ? 0 : theme.rounds.container3Round}
          ${isFlatMode ? 0 : theme.rounds.container3Round} 0px 0px;
      `;
    }
    return css``;
  }}
`;
